import React from 'react';
import {View, StyleSheet, ViewStyle} from 'react-native';
import {Sizes} from '../index';
import {ComponentProps} from './ComponentProps';

interface PillProps extends ComponentProps {
  color?: string;
  borderColor?: string;
  // restricts width to its child if true. default: false
  widthFitsChildren?: boolean;
  height?: number;
  paddingHorizontal?: number;
}

export const Pill = (props: React.PropsWithChildren<PillProps>) => {
  const widthFitsChildren = props.widthFitsChildren ?? false;
  const height = props.height ?? 50;
  let pillStyle: ViewStyle[] = [
    styles.container,
    {
      height: height,
      borderRadius: height / 2,
      paddingHorizontal: props.paddingHorizontal ?? Sizes.l,
    },
  ];
  if (props.color) {
    pillStyle.push({backgroundColor: props.color});
  }
  if (props.borderColor) {
    pillStyle.push({
      borderColor: props.borderColor,
      borderWidth: 1,
      borderStyle: 'solid',
    });
  }
  return (
    <View style={props.containerStyle}>
      <View style={widthFitsChildren ? styles.widthFitsChildren : {}}>
        <View style={pillStyle} testID={props.testID}>
          {props.children}
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  widthFitsChildren: {
    alignItems: 'flex-start',
  },
});
